/**
 * Bubbling DOM event an `Accordion` listens for on its root. Dispatching it
 * from any descendant opens every closed accordion above that element, which
 * is how a deep link can surface content folded away in nested sections.
 */
export const ACCORDION_REVEAL_EVENT = 'k2:reveal';

export const requestReveal = (element: Element) => {
  element.dispatchEvent(
    new CustomEvent(ACCORDION_REVEAL_EVENT, { bubbles: true }),
  );
};
